import { useEffect, useState, useMemo, useContext } from 'react';
import { usePersistentState } from './usePersistentState';
import { useLocalStorage } from "@penseapp/uselocalstorage";
import useApi from "./useApi";
import { HotelContext } from '../context/hotel';

export const useDetail = (entity) => {
    const { data: hotel, cacheVersion } = useContext(HotelContext);

    const [loading, setLoading] = useState(false);
    const [item, setItem] = useState(null)
    // const [item, setItem] = usePersistentState(`${entity}-${cacheVersion}-${id}`, null, 30);
    // const [ item, setItem ] = useLocalStorage(`${hotel.id}-${entity}-${id}-${cacheVersion}`, null, 60 * 30);
    const [error, setError] = useState(null);
    const { get } = useApi();

    const images = useMemo(() => {
        if (item == null) return [];
        return item.gallery && item.gallery.length > 0 ? item.gallery : [item.photo];
    }, [item]);

    const getFetch = (id) => {
        if (!hotel || !id) {
            setError("Invalid hotel or id");
            return null;
        }
        const url = `hotels/${hotel.id}/${entity}/${id}`;
        return get(url);
    };

    const loadItem = async (id) => {
        setLoading(true);

        const _fetch = getFetch(id);
        if (_fetch) {
            try {
                const response = await _fetch;
                if (response) {
                    setItem(response);
                } else {
                    setError(`No response for '${entity}'`);
                }
            } catch (err) {
                setError(`Error fetching '${entity}': ${err.message}`);
            } finally {
                setLoading(false);
            }
        }
    };

    // useEffect(() => {
    //     if (item === null) {
    //         loadItem();
    //     }
    // }, []);

    // useEffect(() => {
    //     console.log('27ene id', id);
    //     console.log('27ene id', item?.id);
    //     if (id && item?.id != id) {
    //         getFetch();
    //     }
    // }, [id]);

    return {
        loadItem,
        loading,
        item,
        images,
        error
    };
};
